import { SxProps } from "@mui/material"

export const sxLabel: SxProps = {
  fontFamily: 'Unimed-Sans',
  color: '#383838',
  fontWeight: 600,
}

export const sxValidationMessage: SxProps = {
  fontFamily: 'Unimed-Sans',
  color: '#D84141',
  fontSize: 12
}

export const sxButtonLogin: SxProps = {
  borderRadius: '80px',
  height: '44px',
  padding: '24px 32px',
  '@media (max-width: 900px)': {
    width: '100%'
  },
}

export const sxInputEmail: SxProps = {
  fontFamily: 'Unimed-Sans',
  color: '#383838',
  fontWeight: 400,
  fontSize: '14px',
}
